const zh = {
  i18nView: {
    login: '登录',
    account: '账号',
    mainTip: '开启顺畅模式后，您在主网上的操作所消耗的CPU/NET资源将由TokenPocket帮您支付，您可以顺畅的使用钱包',
    remainCount: '您当前剩余网络费用',
    status: '开启状态',
    buyTimes: '请选择充值数量',
    pay: '支付',
    times: '次',
    buy: '购买',
    betaTip: '每账号每天最多可购买 6 CNY 的资源。',
    success: '购买成功',
    claimSuccess: '执行成功',
    currentFee: '当前费率',
    radioTips: '每次链上操作消耗的费用取决于操作消耗的CPU时间，一次普通账号之间的转账操作消耗在 0.3 ms 左右。',
    ramTips: '第一次开通顺畅模式,会消耗少量内存,如内存不足会在开通时自动购买',
    quotaTips: '当可用资源费少于',
    quotaTips1: "时请及时补充资源费,以免操作失败。",
    overThreshold: '购买的资源已超出本日限额',
    copied: '已复制',
    copiedFailed: '复制失败,请手动复制',
    pleaseView: '请在',
    activeFun: '中开启代付功能',
    rechargeAccount: '充值账号',
    self: '自己',
    other: '他人',
    inputAccount: '输入要充值的账号',
    aboutMode: '关于顺畅模式',
    referRule: '邀请奖励细则',
    referRule1: '用户 A 邀请用户 B 在TP钱包“顺畅模式”成功支付后，A即可成为B的长期（3个月）推荐人。期间 B 每次支付代币获取网络费，A都会获得10%代币返佣，返佣需要手动领取。',
    referRule2: '如B绑定为A的被推荐人后，使用了用户C的邀请链接购买资源，则A和C分别得4%,6%的返佣。',
    referRule4: '邀请人必须在本次更新后购买过资源方可邀请，邀请奖励需最少达 1 EOS 或 1 TPT 才可进行领取。',
    claimRefer: '领取奖励',
    youhaveRefer: '你已成功邀请',
    yourReward: '您的奖励',
    copy: '复制链接',
    referTitle: '邀请奖励',
    accountError: "请填写正确的充值账号",
    rightTip: '本规则解释权归 TokenPocket 所有',
    pay: '支付',
    payTipsPart1: '大约可转账',
    payTipsPart2: '次',
    whatisForget: '什么是顺畅模式？',
    whatisForget1: '在EOS主网上做操作都需要消耗一定资源，如CPU和NET；但是这些概念太复杂了，给用户执行操作带来了很多困扰；因此我们推出顺畅模式，去除CPU和NET概念，用户只需支付非常少的费用即可轻松执行链上操作。',
    gift: '新人礼包',
    giftTip1: '所有EOS账号均可领取<em> 5ms </em>的网络费,大概可执行普通转账<em> 15次 </em>, 另外于12月9日后注册的EOS账号可以领取双倍的资源费用。',
    openintp: '请在TokenPocket钱包中领取',
    claimAndOpen: '领取并开启顺畅模式',
    claimed: '已领取',
    whereis: '入口在哪？',
    whereisTip: '可以在资产页面顶部的“小闪电”进入顺畅模式，进行顺畅模式的开关及充值；同时也可以邀请朋友使用，赚取返佣。建议在自身资源不足时开启顺畅模式。',
    forgetPro: '顺畅模式PRO',
    forgetProTip: 'TokenPocket提供了项目方为用户代付资源的方案，采用该方案的DAPP，用户无需CPU 也无需开启顺畅模式，即可顺畅体验游戏。点击下面DAPP即可进入',
    share: '分享给好友'
  }
};

export default zh;